import React from 'react';
import { StudyGuideMyGuideLvlTag } from './study-guide-my-guide-lvl-tag';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export function StudyGuideMyGuideDataGrid(props) {
  const { data, height = 'auto' } = props;

  return (
    <div
      className="overflow-y-auto"
      style={{ height: height }}
    >
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead scope="col">Matéria</TableHead>
            <TableHead
              scope="col"
              className="w-[70%] text-right"
            >
              Progresso
            </TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {data?.map((item, key) => (
            <TableRow key={key}>
              <TableHead
                scope="row"
                style={{ paddingTop: 8, paddingBottom: 8 }}
              >
                <span
                  className="truncate"
                  title={item.taxonomy}
                >
                  {item.taxonomy}
                </span>
              </TableHead>
              <TableCell className="text-right">
                <StudyGuideMyGuideLvlTag
                  percentage={item.progress}
                  id={key}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
